export default __webpack_public_path__ + "static/soehne-web-extrafett-kursiv-b21734f4f4e980c3fc5e7673c71afa6a.woff2";